import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PageInfoSalesRequestResultDTO,
  SalesRequestApiService,
  SalesRequestDTO,
  SalesRequestResultDTO,
  SalesRequestStatus,
} from '@app/api/purchase-service-sales';

export interface SalesRequestSearchParams {
  series?: string;
  title?: string;
  status?: SalesRequestStatus | null;
  /** PrimeNG lazy-table offset. */
  first: number;
  rows: number;
}

/** Wraps the purchase-service sales client for the dealer sales request screens. */
@Injectable({ providedIn: 'root' })
export class SalesRequestService {
  private readonly api = inject(SalesRequestApiService);

  search(
    params: SalesRequestSearchParams,
  ): Observable<PageInfoSalesRequestResultDTO> {
    return this.api.page({
      series: params.series?.trim() || undefined,
      title: params.title?.trim() || undefined,
      status: params.status ?? undefined,
      page: Math.floor(params.first / params.rows),
      size: params.rows,
      sortBy: 'id',
      ascending: false,
    });
  }

  getById(id: number): Observable<SalesRequestResultDTO> {
    return this.api.getDetail(id);
  }

  create(body: SalesRequestDTO): Observable<SalesRequestResultDTO> {
    return this.api.create(body);
  }

  approve(id: number): Observable<SalesRequestResultDTO> {
    return this.api.updateStatus(id, 'APPROVED');
  }

  reject(id: number): Observable<SalesRequestResultDTO> {
    return this.api.updateStatus(id, 'REJECTED');
  }

  delete(id: number): Observable<SalesRequestResultDTO> {
    return this.api.delete(id);
  }
}
